import { AlertMessage, ConfigurableText } from '@/app/components'
import { Button, Icon, Modal, Text } from '@/components'

export type InactiveTimesSectionProps = {
  lines: string[]
  onCardClick: () => void
  isModalOpen: boolean
  onCloseModal: () => void
  onEditClick: () => void
}

export default function InactiveTimesSection(props: InactiveTimesSectionProps) {
  const { lines, onCardClick, isModalOpen, onCloseModal, onEditClick } = props
  return (
    <>
      <SetInactiveTimesCard lines={lines} onClick={onCardClick} />
      <Modal
        id="inactive-times-modal"
        open={isModalOpen}
        onClose={onCloseModal}
        title="Save Money is off due to inactive times"
      >
        <div className="flex flex-col gap-3">
          <Text variant="body2">To enable Save Money, edit inactive times</Text>
          <AlertMessage variant="info">
            <div className="flex flex-col gap-1">
              <div className="flex gap-1 text-optiwatt-blue-500">
                <ConfigurableText
                  variant="body2"
                  config={'Save Money will be inactive:'}
                />
              </div>
              <div className="flex flex-col gap-1">
                {lines.map((line, i) => (
                  <Text
                    key={i}
                    variant="body2"
                    className="text-optiwatt-blue-500"
                  >
                    {line}
                  </Text>
                ))}
              </div>
            </div>
          </AlertMessage>
          <div className="mt-2">
            <Button
              variant="primary"
              onClick={onEditClick}
              id="edit-inactive-times-button"
            >
              Edit Inactive Times
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

function SetInactiveTimesCard({
  lines,
  onClick,
}: {
  lines: string[]
  onClick: () => void
}) {
  return (
    <Button id="inactive-times-card" variant="click-wrapper" onClick={onClick}>
      <div className="flex items-start p-4 border border-solid rounded-xl border-base-grey-200">
        <Icon color="blue-500" className="mr-3" size={22} name="Clock" />
        <div className="flex flex-col">
          <div className="text-sm font-bold text-left text-base-grey-700">
            Set Inactive Times
          </div>
          <div className="mt-1 text-xs font-medium text-themed-base-500">
            {lines.length > 0 ? (
              <div className="flex flex-col gap-1 text-left">
                {lines.map((line, idx) => (
                  <span key={idx}>{line}</span>
                ))}
              </div>
            ) : (
              <div className="flex flex-col gap-1 text-left">
                <span>No times set</span>
              </div>
            )}
          </div>
        </div>
        <Icon
          className="self-center ml-auto"
          color="grey-400"
          size={18}
          name="ChevronRight"
        />
      </div>
    </Button>
  )
}
